<header>
	<h1>Запрос статуса</h1>
	<app-svg assetsPath="close" (click)="close$.next()"></app-svg>
</header>
<section>
	<span>{{ statusText }}</span>
</section>
<footer>
	<button (click)="close$.next()">Закрыть</button>
</footer>
